// extracted by mini-css-extract-plugin
export var container = "layout-module--container--51c11";
export var content = "layout-module--content--fad95";